import { render, staticRenderFns } from "./POSControls.vue?vue&type=template&id=46e20879&scoped=true"
import script from "./POSControls.vue?vue&type=script&lang=js"
export * from "./POSControls.vue?vue&type=script&lang=js"
import style0 from "./POSControls.vue?vue&type=style&index=0&id=46e20879&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e20879",
  null
  
)

export default component.exports